module.exports = __webpack_public_path__ + "img/icon-button-resolve-dim.45a70706.svg";